import { ErkomListItem, QueryParamListBase } from '@shared/models';

export interface ErkomListQueryParam
  extends ErkomListItem,
    QueryParamListBase {}
